import React, { useEffect, useState } from "react";
import axios from "axios";
import Notification from "../../../components/Notification/Notification";
import CertificateCard from "../../../components/certificateCard/CertificateCard";
import { useDispatch, useSelector } from "react-redux";
import { getAllstudentCertificateAPI } from "../../../redux/features/studentDetailSlice";
import toast from "react-hot-toast";

const StudentCertificates = () => {
  const [certificates, setCertificates] = useState([]);
  const auth = useSelector((state) => state.auth);
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch();
  console.log("cer ", certificates);

  useEffect(() => {
    const fetchCertificates = async () => {
      try {
        setIsLoading(true)
        const allCertificate = await dispatch(
          getAllstudentCertificateAPI({ token: auth.token })
        ).unwrap();
        setCertificates(allCertificate.data);
        console.log("allCertificate", allCertificate);
        toast.success(
          allCertificate?.message || "Certificates fetched successfully",
          {
            position: "top-center",
          }
        );
      } catch (error) {
        toast.error(error?.message || "Error fetching certificates", {
          position: "top-center",
        });
      }finally{
        setIsLoading(false)
      }
    };

    fetchCertificates();
  }, []);

  return (
    <>
    {isLoading ? (
      <div className="loader-container">
        <div className="dottedLoading theme-color"></div>
      </div>
    ) :(<>
      {/* Topbar */}
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3 className="ad-heading-04 fw-bold mb-8">All Certificates</h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <Notification />
          </div>
        </div>
      </div>

      {/* Certificates List */}
      <div className="card-default-style py-10 py-sm-20 py-md-25 px-10 px-sm-20 px-md-30 px-lg-40 mb-10 mb-sm-20 mb-md-30 mb-lg-44">
        <h1 className="fw-bold ah-heading-03 mb-lg-32 text-center">
          Certificates
        </h1>
        <div className="row course-item-list">
          <CertificateCard fatchData={certificates} />
        </div>
      </div>
      </>)}
    </>
  );
};

export default StudentCertificates;
